import { getCurrentTransferStatus } from '@app/helpers';

import {
    ACTION_RESET_TRANSFERS_STORE,
    ACTION_SET_INCOMING_TRANSFERS,
    ACTION_SET_OUTGOING_TRANSFERS,
    ACTION_SET_PENDING_INCOMING,
    ACTION_SET_TRANSFER_DATA,
    ACTION_SET_TRANSFER_PANEL_OPEN,
    type TransfersActionTypes,
    type TransfersState,
} from '../types/transfers';

const DEFAULT: TransfersState = {
    incomingTransfers: [],
    outgoingTransfers: [],
    transferPanelOpen: false,
    userPendingIncoming: null,
    transferData: {},
};

export function transfers(state: TransfersState = DEFAULT, action: TransfersActionTypes): TransfersState {
    switch (action.type) {
        case ACTION_RESET_TRANSFERS_STORE:
            return DEFAULT;
        case ACTION_SET_INCOMING_TRANSFERS: {
            const incomingAccepted = action.incomingTransfers.filter((t) => t.sender_code_accepted_at !== null);
            const nextIncomingTransfer =
                incomingAccepted?.length > 0 ? incomingAccepted[incomingAccepted?.length - 1] : null;
            return {
                ...state,
                incomingTransfers: action.incomingTransfers,
                userPendingIncoming: nextIncomingTransfer,
            };
        }
        case ACTION_SET_OUTGOING_TRANSFERS: {
            action.outgoingTransfers.forEach((t) => {
                state.transferData[t.eid] = {
                    id: t.id,
                    status: getCurrentTransferStatus({
                        eid: t.eid,
                        outgoingTransfers: action.outgoingTransfers,
                    }).status,
                    recipient_email: t.email,
                };
            });
            return {
                ...state,
                outgoingTransfers: action.outgoingTransfers,
                transferData: { ...state.transferData },
            };
        }
        case ACTION_SET_TRANSFER_PANEL_OPEN:
            return { ...state, transferPanelOpen: action.transferPanelOpen };
        case ACTION_SET_PENDING_INCOMING:
            return { ...state, userPendingIncoming: action.userPendingIncoming };
        case ACTION_SET_TRANSFER_DATA: {
            const transferData = { ...state.transferData, [action.emojiId]: action.transferData };
            return { ...state, transferData: transferData };
        }
        default:
            return { ...state };
    }
}
